import { render, staticRenderFns } from "./UserTrendTableHeader.vue?vue&type=template&id=62ed1b56&scoped=true"
import script from "./UserTrendTableHeader.vue?vue&type=script&lang=ts"
export * from "./UserTrendTableHeader.vue?vue&type=script&lang=ts"
import style0 from "./UserTrendTableHeader.vue?vue&type=style&index=0&id=62ed1b56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ed1b56",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/user-trend/table/user-trend-table-header.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fuser-trend%2Ftable%2FUserTrendTableHeader.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports